module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0117.jpg?v=e90e4cb9";